/* room.js — Raum-Lösungsseite: Ökosystem-Filter (clientseitig) + Anchor-Scroll-Spy.
   Progressive Enhancement: ohne JS sind alle Karten sichtbar, Anker-Links scrollen nativ.
   Keine Abhängigkeiten. FAQ/SEO-Aufklappen läuft über native <details> (kein JS). */
(function () {
  var root = document.querySelector('.hm-room');
  if (!root) return;

  var ECO_NAMES = {
    'matter': 'Matter', 'apple-home': 'Apple Home', 'alexa': 'Alexa',
    'google-home': 'Google Home', 'smartthings': 'SmartThings', 'home-assistant': 'Home Assistant', 'homey': 'Homey'
  };

  var filterWrap = root.querySelector('[data-room-filter]');
  var ecoBtns = filterWrap ? Array.prototype.slice.call(filterWrap.querySelectorAll('[data-room-eco]')) : [];
  var chipsBox = filterWrap ? filterWrap.querySelector('[data-room-chips]') : null;
  var chipList = filterWrap ? filterWrap.querySelector('[data-room-chiplist]') : null;
  var active = Object.create(null);

  function activeKeys() { return Object.keys(active); }

  function syncButtons() {
    ecoBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', active[b.getAttribute('data-room-eco')] ? 'true' : 'false');
    });
  }

  // Bridge-Pattern (docs/14): DOM-Event auf document, analytics.js publiziert
  // es consent-gated als 'homedia:select_ecosystem' an die Web-Pixels-Ebene.
  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  function apply() {
    var keys = activeKeys();
    // Karten ein-/ausblenden
    Array.prototype.forEach.call(root.querySelectorAll('[data-room-card]'), function (card) {
      var ecos = (card.getAttribute('data-ecosystems') || '').split(/\s+/);
      var show = keys.length === 0 || keys.some(function (k) { return ecos.indexOf(k) !== -1; });
      card.classList.toggle('is-hidden', !show);
    });
    // Pro Abschnitt: Empty-State, wenn nichts mehr passt
    Array.prototype.forEach.call(root.querySelectorAll('[data-room-section]'), function (sec) {
      var grid = sec.querySelector('[data-room-grid]');
      var empty = sec.querySelector('[data-room-empty]');
      if (!grid || !empty) return;
      var visible = Array.prototype.some.call(grid.querySelectorAll('[data-room-card]'), function (c) {
        return !c.classList.contains('is-hidden');
      });
      empty.hidden = visible;
      grid.style.display = visible ? '' : 'none';
    });
    // Chips
    if (chipsBox) {
      chipsBox.hidden = keys.length === 0;
      if (chipList) {
        chipList.textContent = '';
        keys.forEach(function (k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'hm-room__chip';
          b.innerHTML = (ECO_NAMES[k] || k) + ' <span aria-hidden="true">×</span>';
          b.setAttribute('aria-label', (ECO_NAMES[k] || k) + ' entfernen');
          b.addEventListener('click', function () { delete active[k]; syncButtons(); apply(); });
          chipList.appendChild(b);
        });
      }
    }
  }

  ecoBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-room-eco');
      if (active[k]) { delete active[k]; } else { active[k] = true; emit('room:select_ecosystem', { system: ECO_NAMES[k] || k, system_key: k }); }
      syncButtons();
      apply();
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-room-clear]'), function (btn) {
    btn.addEventListener('click', function () {
      Object.keys(active).forEach(function (k) { delete active[k]; });
      syncButtons();
      apply();
    });
  });

  // Anchor-Scroll-Spy (aktive Pille markieren)
  var anchors = Array.prototype.slice.call(root.querySelectorAll('[data-room-anchor]'));
  if (anchors.length && 'IntersectionObserver' in window) {
    var map = {};
    anchors.forEach(function (a) {
      var id = a.getAttribute('data-room-anchor');
      if (document.getElementById(id)) map[id] = a;
    });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          anchors.forEach(function (a) { a.classList.remove('is-active'); });
          if (map[e.target.id]) map[e.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(map).forEach(function (id) { obs.observe(document.getElementById(id)); });
  }
})();
